import RouteItem from ".";
//Admission SubMenu Pages
import AdmissionProcedureBPT from "../pages/admission/Admission-procedure-BPT";
import AdmissionProcedureMPT from "../pages/admission/Admission-procedure-MPT";

export const admissionRoutes: RouteItem =
  //admission page route
  {
    key: "router-admission",
    title: "Admissions",
    tooltip: "Admissions",
    path: "/admission",
    enabled: true,
    appendDivider: true,
    showInHeader: true,
    subRoutes: [
      {
        key: "router-admission-BPT",
        title: "Bachelor's of Physiotherapy",
        tooltip: "Admission - Bachelor's of Physiotherapy",
        path: "admission-procedure-BPT",
        enabled: true,
        component: AdmissionProcedureBPT,
        appendDivider: true,
      },
      {
        key: "router-admission-MPT",
        title: "Master's of Physiotherapy",
        tooltip: "Admission - Master's of Physiotherapy",
        path: "admission-procedure-MPT",
        enabled: true,
        component: AdmissionProcedureMPT,
        appendDivider: true,
      },
      // {
      //   key: "router-admission-procedure",
      //   title: "Admission Brochure & Procedure",
      //   tooltip: "Admission Brochure & Procedure",
      //   path: "admission-procedure",
      //   enabled: true,
      //   component: PageUnderConstruction,
      //   appendDivider: true,
      // },
      // {
      //   key: "router-admission-form",
      //   title: "Admission Form",
      //   tooltip: "Admission Form",
      //   path: "admission-form",
      //   enabled: true,
      //   component: AdmissionForm,
      //   appendDivider: true,
      // },
    ],
  };
